import { AppColors } from "@/styles/colors";
import { Button, Flex } from "@chakra-ui/react";
import { Download } from "lucide-react";
import { openOnboardingFile } from "../../../schema/auxiliar-handlers";

interface Props {
  disabled: boolean;
  showMustStartReviewToast: () => void;
  url?: string;
  filename?: string;
}

export const DownloadButton = ({
  disabled,
  showMustStartReviewToast,
  url,
  filename,
}: Props) => {
  return (
    <Flex display="inline-flex">
      <Button
        width="32px"
        height="32px"
        padding="0"
        bgColor={AppColors.BLACK_TEXT_SECONDARY}
        disabled={disabled}
        onClick={() => openOnboardingFile({
          disabled,
          showMustStartReviewToast,
          url,
          filename
        })}
        opacity={disabled ? 0.6 : 1}
        cursor={disabled ? "not-allowed" : "pointer"}
        aria-label="Descargar"
      >
        <Download size={16} color={AppColors.WHITE_SECONDARY} />
      </Button>
    </Flex>
  );
};
